/*
 * Copyright (C) 2026 The Android Open Source Project
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
package com.bikompanion.ui.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.addPathNodes
import androidx.compose.ui.unit.dp

val MaterialLock: ImageVector
    get() {
        if (_MaterialLock != null) return _MaterialLock!!

        _MaterialLock = ImageVector
            .Builder(
                name = "lock",
                defaultWidth = 24.dp,
                defaultHeight = 24.dp,
                viewportWidth = 960f,
                viewportHeight = 960f,
            ).apply {
                addPath(
                    pathData = addPathNodes(
                        "M240,880Q207,880 183.5,856.5Q160,833 160,800L160,400Q160,367 183.5,343.5Q207,320 240," +
                            "320L280,320L280,240Q280,157 338.5,98.5Q397,40 480,40Q563,40 621.5,98.5Q680,157 680," +
                            "240L680,320L720,320Q753,320 776.5,343.5Q800,367 800,400L800,800Q800,833 776.5,856.5Q753," +
                            "880 720,880L240,880ZM240,800L720,800Q720,800 720,800Q720,800 720,800L720,400Q720,400 720," +
                            "400Q720,400 720,400L240,400Q240,400 240,400Q240,400 240,400L240,800Q240,800 240," +
                            "800Q240,800 240,800ZM536.5,656.5Q560,633 560,600Q560,567 536.5,543.5Q513,520 480," +
                            "520Q447,520 423.5,543.5Q400,567 400,600Q400,633 423.5,656.5Q447,680 480,680Q513,680 536.5," +
                            "656.5ZM360,320L600,320L600,240Q600,190 565,155Q530,120 480,120Q430,120 395,155Q360," +
                            "190 360,240L360,320ZM240,800Q240,800 240,800Q240,800 240,800L240,400Q240,400 240," +
                            "400Q240,400 240,400L240,400Q240,400 240,400Q240,400 240,400L240,800Q240,800 240," +
                            "800Q240,800 240,800Z",
                    ),
                    fill = SolidColor(Color.Black),
                )
            }.build()

        return _MaterialLock!!
    }

private var _MaterialLock: ImageVector? = null
